
export const PREPROCESS_PENDING = "PREPROCESS_PENDING";
export const PREPROCESS = "PREPROCESS";
export const PREPROCESS_FAILED = "PREPROCESS_FAILED";

export const PREPROCESS_CONFIGS_PENDING = "PREPROCESS_CONFIGS_PENDING";
export const PREPROCESS_CONFIGS = "PREPROCESS_CONFIGS";
export const PREPROCESS_CONFIGS_FAILED = "PREPROCESS_CONFIGS_FAILED";

export const RESET_PREPROCESS = "RESET_PREPROCESS";